import React, { useEffect } from 'react';
import './dashboard.css';
import { Card } from '../card/card';
import { Container, Row, Col } from 'react-bootstrap';
import { TotalLoggedInEmployee } from './TotalLoggedInEmployee/TotalLoggedInEmployee';
import Calender from './calender/calender';
import ActiveProjects from './activeProjects/activeProjects';
import RecentActivities from './recentActivities/recentActivities';
import { CardCalender } from '../card/CardCalender';
import { TeamLeaves } from './teamLeaves/teamLeaves';
import { useTranslation } from 'react-i18next';
import Aos from 'aos';


const Dashboard = ({ adminIds, empRole }) => {
    //console.log("role of the loggedin employee is on dashboard", empRole);

    const { t } = useTranslation();


    useEffect(() => {
        //console.log("Employee IDs managed by the logged-in user:", adminIds);
    }, [adminIds]);

    useEffect(() => {
        Aos.init({
            // Global settings:
            disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
            startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
            initClassName: 'aos-init', // class applied after initialization
            animatedClassName: 'aos-animate', // class applied on animation
            useClassNames: false, // if true, will add content of `data-aos` as classes on scroll

            // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
            offset: 0, // offset (in px) from the original trigger point
            delay: 0, // values from 0 to 3000, with step 50ms
            duration: 300, // values from 0 to 3000, with step 50ms
            easing: 'ease', // default easing for AOS animations
            once: false, // whether animation should happen only once - while scrolling down
            mirror: false, // whether elements should animate out while scrolling past them
            anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
        });
    }, []);

    return (
        <div className='dashboard'>
            <Container fluid>
                <Row>
                    <Col sm={12} md={""} lg={4}>
                        <Row>
                            <Col sm={12} md={""} lg={12} style={{ margin: '10px 0' }} data-aos="fade-right">
                                <Card
                                    cardheader={t("dashboard_currentWorking")}
                                    cardbody={<TotalLoggedInEmployee adminIds={adminIds} empRole={empRole} />}
                                    cardfooter={t("dashboard_currTotal")}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} md={""} lg={12} style={{ margin: '10px 0' }} data-aos="fade-left">
                                <Card
                                    cardheader={t("dashboard_recent")}
                                    cardbody={<RecentActivities adminIds={adminIds} empRole={empRole} />}
                                    cardfooter={t("dashboard_todayActivity")}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col sm={12} md={""} lg={4}>
                        <Row>
                            <Col sm={12} md={""} lg={12} style={{ margin: '10px 0' }} data-aos="fade-left">
                                <Card
                                    cardheader={t("dashboard_leavetitle")}
                                    cardbody={<TeamLeaves adminIds={adminIds} empRole={empRole} />}
                                    cardfooter={''}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col sm={12} md={""} lg={4}>
                        <Row>
                            <Col sm={12} md={""} lg={12} style={{ margin: '10px 0' }} data-aos="fade-right">
                                <Card
                                    cardheader={t("dashboard_calendar")}
                                    cardbody={<Calender />}
                                    cardfooter={''}
                                />
                            </Col>
                        </Row>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Dashboard;
